import React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { useVideoPlayer, VideoView } from 'expo-video';
import { Ionicons } from '@expo/vector-icons';
import { useTheme } from '../../theme/ThemeContext';
import ThemedText from '../common/ThemedText';

interface SelectedVideoPreviewProps {
  uri: string;
  subtitle?: string;
  onRemove?: () => void;
  muted?: boolean;
}

const SelectedVideoPreview: React.FC<SelectedVideoPreviewProps> = ({
  uri,
  subtitle,
  onRemove,
  muted = false,
}) => {
  const { theme } = useTheme();
  const player = useVideoPlayer(uri, (instance) => {
    instance.loop = true;
    instance.muted = muted;
    instance.volume = 1;
  });

  return (
    <View style={styles.container}>
      <VideoView
        style={[styles.video, { backgroundColor: theme.backgroundSecondary, borderColor: theme.border }]}
        player={player}
        allowsFullscreen
        nativeControls
        contentFit="contain"
      />
      {subtitle ? (
        <ThemedText style={[styles.subtitle, { color: theme.textSecondary }]} numberOfLines={1}>
          {subtitle}
        </ThemedText>
      ) : null}
      {onRemove ? (
        <TouchableOpacity style={styles.removeButton} onPress={onRemove}>
          <Ionicons name="close-circle" size={32} color="#FFFFFF" />
        </TouchableOpacity>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    marginBottom: 16,
  },
  video: {
    width: '100%',
    aspectRatio: 1,
    borderRadius: 12,
    borderWidth: 1,
    overflow: 'hidden',
  },
  subtitle: {
    fontSize: 12,
    marginTop: 8,
  },
  removeButton: {
    position: 'absolute',
    top: 8,
    right: 8,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    borderRadius: 16,
  },
});

export default SelectedVideoPreview;
